// Comment Set #1, PD 7: "Update default state: Border is #C6CFC6. Pin outline is #4F5F4A" and
// "Update hover/focused states to #4F5F4A for both border and shaded pin".
//
// His two colours are the drawn ones. `property-dashboard/Frame 443_2/btn_49` in
// files/sow2-section-lean.svg is the 39x39 r 19.5 circle on this screen with a #C6CFC6 edge, and the
// two glyph paths inside it (`M6414.75 1224.25...`, `M6425.32 1207.75...`) are stroked #4F5F4A. The
// hover pair comes from the states annotation beside it, `hover-state/Frame 444_46/btn_47`: #4F5F4A
// on the circle with the head filled.
//
// What actually changed is which axis those two pairs live on. This component used to map them to
// PINNED and UNPINNED; his item makes them DEFAULT and HOVER.
//
// **Pinned keeps its own colour, and the first attempt at this got it wrong.** He names default and
// hover and says nothing about pinned, so the pass on 02.09 gave pinned the hover look — and
// `logic-auditor` measured what that produces: five of the six combinations of (pinned, hovered,
// focused) paint the identical picture, so pressing the button changes nothing while the pointer is
// still on it, and a keyboard user who tabs to the control can never read the state at all, because
// their own focus is what hides it. Pinned therefore stays #547A42, the colour it already had and
// the one the states annotation draws on the shaded pin (`hover-state/Frame 444_46`), which leaves
// all four reachable states distinguishable:
//
//   unpinned, at rest      ring #C6CFC6, head unfilled
//   unpinned, hover/focus  ring #4F5F4A, head filled #4F5F4A   — his 7.2, a preview of pinning
//   pinned, at rest        ring #547A42, head filled #547A42
//   pinned, hover/focus    unchanged — a state already on has nothing to preview
//
// Hover and focus are CSS rather than React state: the classes are Tailwind utilities on the SVG
// nodes, which set the `stroke`/`fill` CSS properties and so beat the presentation attributes
// underneath them. The button that wraps this carries `group`.
//
// `transition-colors` sits on these nodes and not on the button. It was on the button first, and it
// did nothing there: `transition-property` is not inherited, and the button's own fill and stroke
// never change — only the rect's and the path's do.
export function DashboardPinIcon({ active }) {
  const ringCls = active
    ? 'stroke-[#547A42] transition-colors'
    : 'stroke-[#C6CFC6] group-hover:stroke-[#4F5F4A] group-focus-visible:stroke-[#4F5F4A] transition-colors'

  // The head is the only path the export fills, and filling it is what "shaded" means.
  const headCls = active
    ? 'stroke-[#547A42] fill-[#547A42] transition-colors'
    : 'stroke-[#4F5F4A] fill-none group-hover:fill-[#4F5F4A] group-focus-visible:fill-[#4F5F4A] transition-colors'

  // The two straight segments follow the head's outline so a pinned pin is one colour throughout.
  const shaftCls = active ? 'stroke-[#547A42] transition-colors' : 'stroke-[#4F5F4A] transition-colors'

  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" fill="white"/>
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" className={ringCls}/>
      <g clipPath="url(#clip0_dash_pin)">
        <path d="M11.75 28.25L17.3738 22.6262" className={shaftCls} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M27.2605 16.6945L22.7764 21.1786C23.2747 23.0446 22.7919 25.1181 21.328 26.582L13.418 18.672C14.8818 17.2081 16.9553 16.7253 18.8214 17.2236L23.3055 12.7395" className={headCls} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M22.3203 11.7472L28.2528 17.6797" className={shaftCls} fill="none" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_dash_pin">
          <rect width="18" height="18" fill="white" transform="translate(11 11)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
